/* eslint-disable */

export type ApiType = 'arcgis' | 'wind';

export interface Layer {
  title: string;
  id?: number;
  api?: ApiType;
  png32?: number;
  children?: Layer[];
}

export const mockLayers: Layer[] = [
  {
    title: 'Informações Adicionais',
    children: [
      { title: 'Bases de Estações Anemométricas - AMA', id: 84, api: 'arcgis' },
      { title: 'Bases de estações fluviométricas' },
      { title: 'Bases de estações pluviométricas' },
    ],
  },
  {
    title: 'Unidades Administrativas',
    children: [
      { title: 'Municípios PE' },
      { title: 'Estado PE' },
      { title: 'Limite BRA' },
      { title: 'Estados BRA' },
    ],
  },
  {
    title: 'Potencial Eólico',
    children: [
      // { title: 'Velocidade do vento (10m/s)' },
      // { title: 'Velocidade do vento (50m/s)', id: 50, api: 'wind' },
      {
        title: 'Velocidade do vento (100m/s)',
        id: 86,
        api: 'arcgis',
        png32: 1,
      },
      {
        title: 'Velocidade do vento (150m/s)',
        id: 87,
        api: 'arcgis',
        png32: 1,
      },
      {
        title: 'Velocidade do vento (200m/s)',
        id: 88,
        api: 'arcgis',
        png32: 1,
      },
    ],
  },
  {
    title: 'Sistema Elétrico Existente',
    children: [
      { title: 'Parques Eólicos', id: 112, api: 'arcgis' },
      { title: 'Usinas Fotovotaicas', id: 113, api: 'arcgis' },
      { title: 'Usinas Hidrelétricas', id: 114, api: 'arcgis' },
      { title: 'Centrais Geradoras Hidrelétricas', id: 116, api: 'arcgis' },
      {
        title: 'Usinas de combustível fóssil (Termelétricas)',
        id: 118,
        api: 'arcgis',
      },
      { title: 'Linhas de Transmissão', id: 121, api: 'arcgis' },
      { title: 'Subestações', id: 120, api: 'arcgis' },
    ],
  },
  {
    title: 'Sistema Elétrico Planejado',
    children: [
      {
        title: 'Parques Eólicos - Sistema Elétrico Planejado',
        id: 100,
        api: 'arcgis',
      },
      {
        title: 'Linhas de Transmissão - Sistema Elétrico Planejado',
        id: 109,
        api: 'arcgis',
      },
      {
        title: 'Subestações - Sistema Elétrico Planejado',
        id: 108,
        api: 'arcgis',
      },
      {
        title: 'Usinas Fotovoltaicas - Sistema Elétrico Planejado',
        id: 101,
        api: 'arcgis',
      },
    ],
  },
  {
    title: 'Bases de Combustíveis',
    children: [
      { title: 'Petróleo e Derivados', id: 3, api: 'arcgis' },
      {
        title: 'Regasificação Gás Natural Liquefeito (GNL)',
        id: 218,
        api: 'arcgis',
      },
      { title: 'Gás Liquefeito de Petróleo (GLP)', id: 1, api: 'arcgis' },
      { title: 'Bases de Combustíveis', id: 0, api: 'arcgis' },
      {
        title: 'Exploração e Produção de Hidrocarbonetos',
        id: 42,
        api: 'arcgis',
      },
    ],
  },
  {
    title: 'Socioambiental',
    children: [
      { title: 'Unidades de Conservação Ambiental', id: 73, api: 'arcgis' },
      { title: 'Territórios quilombolas', id: 71, api: 'arcgis' },
      { title: 'Terras indígenas (Homologadas)', id: 70, api: 'arcgis' },
      { title: 'Sítios Arqueológicos', id: 69, api: 'arcgis' },
      {
        title: 'Aves Migratórias (Áreas de Concentração)',
        id: 202,
        api: 'arcgis',
      },
      { title: 'Cavernas', id: 67, api: 'arcgis' },
    ],
  },
  {
    title: 'Infraestrutura de Transportes',
    children: [
      { title: 'Gasodutos de distribuição', id: 212, api: 'arcgis' },
      { title: 'Gasodutos de transporte', id: 213, api: 'arcgis' },
    ],
  },
  {
    title: 'Potencial Solar',
    children: [
      {
        title: 'Irradiação Global Horizontal Anual (Wh/m².dia)',
        id: 90,
        api: 'arcgis',
        png32: 1,
      },
      {
        title: 'Irradiação Direta Normal Anual (Wh/m².dia)',
        id: 91,
        api: 'arcgis',
        png32: 1,
      },
      {
        title: 'Irradiação no Plano Inclinado Anual (Wh/m².dia)',
        id: 92,
        api: 'arcgis',
        png32: 1,
      },
    ],
  },
];
